// dateFormats.js
export const DATE_DISPLAY_FORMAT = 'DD/MM/YYYY'
export const DATE_DISPLAY_FORMAT_HOURS = 'HH:mm - DD/MM/YYYY'
